import React from "react";
import { AppBtn } from "../../../ui/buttons";
import Modal, { ModalBody, ModalFooter } from "../../../ui/modal-full";
import { DeliveryArea, StoreInterface } from "@/assets/interfaces";
import DataAccordion from "@/components/ui/data-accordion";

interface Props {
  store: StoreInterface;
  show: boolean;
  toggle: (state: boolean) => void;
  faqs: {
    question: string;
    answer: string;
  }[];
}

const FaqModal: React.FC<Props> = ({ store, show, toggle, faqs }) => {
  return (
    <Modal {...{ show, toggle }} fullOnlyOnMobile title="Frequently Asked Questions" bgClose={false}>
      <ModalBody>
        <div className="flex flex-col items-center gap-2.5">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b last:border-none border-grey-divider w-full">
              <DataAccordion defaultClosed={index != 0} title={faq.question}>
                <p className="text-sm text-black-muted mt-2.5 whitespace-pre-line">{faq.answer}</p>
              </DataAccordion>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default FaqModal;
